import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forYou = ['Quieres regalarle algo memorable sin gastar de más', 'Tu papá ama el asado pero la carne siempre queda dura', 'Se te acabó el tiempo para despachos y necesitas el regalo YA'];
const notForYou = ['Buscas un libro de recetas genéricas argentinas', 'Tu papá prefiere el fútbol al asado'];
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function QualificationSection() {
  return <section className="bg-bbq-dark py-12 md:py-24 px-4 border-t border-white/5" data-id="element-178">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-179">
        {/* Para ti */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="bg-bbq-surface border border-bbq-ember/30 rounded-2xl p-8" data-id="element-180">
          <h2 className="text-2xl md:text-3xl font-display font-bold text-white uppercase tracking-wide mb-6" data-id="element-181">
            Este pack es <span className="text-bbq-ember" data-id="element-182">perfecto</span> si:
          </h2>
          <ul className="space-y-4" data-id="element-183">
            {forYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-200" data-id="element-184">
                <span className="mt-0.5 shrink-0 bg-green-500/15 text-green-500 rounded-full p-1" data-id="element-185">
                  <Check size={18} aria-hidden="true" data-id="element-186" />
                </span>
                <span className="leading-relaxed" data-id="element-187">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* No para ti */}
      </div>
    </section>;
}